/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Lutely API
 * Lutely API
 * OpenAPI spec version: local
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AccountDto,
  AccountSessionDto,
  CapabilitiesResponseDto,
  CustomerSessionDto,
  DashboardLinkResponseDto,
  NextPayoutDto,
  OnboardingLinkRequestDto,
  OnboardingLinkResponseDto,
  PendingTransfersSummaryDto,
  SalesHistoryResponseDto,
  SalesProductDto,
  StripeControllerExportSalesCsvParams,
  StripeControllerGetSalesHistoryParams,
  StripeControllerGetSalesProductsParams,
  StripeSubscriptionDto,
} from ".././dtos";

import { apiRequest } from "../../api-request";
import type { ErrorType, BodyType } from "../../api-request";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const stripeControllerGetStripeAccount = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<AccountDto>(
    { url: `/stripe/account`, method: "GET", signal },
    options,
  );
};

export const getStripeControllerGetStripeAccountQueryKey = () => {
  return [`/stripe/account`] as const;
};

export const getStripeControllerGetStripeAccountQueryOptions = <
  TData = Awaited<ReturnType<typeof stripeControllerGetStripeAccount>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof stripeControllerGetStripeAccount>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getStripeControllerGetStripeAccountQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof stripeControllerGetStripeAccount>>
  > = ({ signal }) => stripeControllerGetStripeAccount(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof stripeControllerGetStripeAccount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type StripeControllerGetStripeAccountQueryResult = NonNullable<
  Awaited<ReturnType<typeof stripeControllerGetStripeAccount>>
>;
export type StripeControllerGetStripeAccountQueryError = ErrorType<unknown>;

export function useStripeControllerGetStripeAccount<
  TData = Awaited<ReturnType<typeof stripeControllerGetStripeAccount>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetStripeAccount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stripeControllerGetStripeAccount>>,
          TError,
          Awaited<ReturnType<typeof stripeControllerGetStripeAccount>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useStripeControllerGetStripeAccount<
  TData = Awaited<ReturnType<typeof stripeControllerGetStripeAccount>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetStripeAccount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stripeControllerGetStripeAccount>>,
          TError,
          Awaited<ReturnType<typeof stripeControllerGetStripeAccount>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStripeControllerGetStripeAccount<
  TData = Awaited<ReturnType<typeof stripeControllerGetStripeAccount>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetStripeAccount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useStripeControllerGetStripeAccount<
  TData = Awaited<ReturnType<typeof stripeControllerGetStripeAccount>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetStripeAccount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getStripeControllerGetStripeAccountQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const stripeControllerGetStripeAccountByStripeId = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<AccountDto>(
    { url: `/stripe/account/${id}`, method: "GET", signal },
    options,
  );
};

export const getStripeControllerGetStripeAccountByStripeIdQueryKey = (
  id?: string,
) => {
  return [`/stripe/account/${id}`] as const;
};

export const getStripeControllerGetStripeAccountByStripeIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof stripeControllerGetStripeAccountByStripeId>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetStripeAccountByStripeId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getStripeControllerGetStripeAccountByStripeIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof stripeControllerGetStripeAccountByStripeId>>
  > = ({ signal }) =>
    stripeControllerGetStripeAccountByStripeId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof stripeControllerGetStripeAccountByStripeId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type StripeControllerGetStripeAccountByStripeIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof stripeControllerGetStripeAccountByStripeId>>
>;
export type StripeControllerGetStripeAccountByStripeIdQueryError =
  ErrorType<unknown>;

export function useStripeControllerGetStripeAccountByStripeId<
  TData = Awaited<
    ReturnType<typeof stripeControllerGetStripeAccountByStripeId>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetStripeAccountByStripeId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof stripeControllerGetStripeAccountByStripeId>
          >,
          TError,
          Awaited<ReturnType<typeof stripeControllerGetStripeAccountByStripeId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useStripeControllerGetStripeAccountByStripeId<
  TData = Awaited<
    ReturnType<typeof stripeControllerGetStripeAccountByStripeId>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetStripeAccountByStripeId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof stripeControllerGetStripeAccountByStripeId>
          >,
          TError,
          Awaited<ReturnType<typeof stripeControllerGetStripeAccountByStripeId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStripeControllerGetStripeAccountByStripeId<
  TData = Awaited<
    ReturnType<typeof stripeControllerGetStripeAccountByStripeId>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetStripeAccountByStripeId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useStripeControllerGetStripeAccountByStripeId<
  TData = Awaited<
    ReturnType<typeof stripeControllerGetStripeAccountByStripeId>
  >,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetStripeAccountByStripeId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getStripeControllerGetStripeAccountByStripeIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const stripeControllerCreateStripeAccount = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<AccountDto>(
    { url: `/stripe/account/create`, method: "POST", signal },
    options,
  );
};

export const getStripeControllerCreateStripeAccountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stripeControllerCreateStripeAccount>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stripeControllerCreateStripeAccount>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["stripeControllerCreateStripeAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stripeControllerCreateStripeAccount>>,
    void
  > = () => {
    return stripeControllerCreateStripeAccount(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StripeControllerCreateStripeAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof stripeControllerCreateStripeAccount>>
>;

export type StripeControllerCreateStripeAccountMutationError =
  ErrorType<unknown>;

export const useStripeControllerCreateStripeAccount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof stripeControllerCreateStripeAccount>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof stripeControllerCreateStripeAccount>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getStripeControllerCreateStripeAccountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const stripeControllerGetAccountSession = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<AccountSessionDto>(
    { url: `/stripe/account/session`, method: "POST", signal },
    options,
  );
};

export const getStripeControllerGetAccountSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stripeControllerGetAccountSession>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stripeControllerGetAccountSession>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["stripeControllerGetAccountSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stripeControllerGetAccountSession>>,
    void
  > = () => {
    return stripeControllerGetAccountSession(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StripeControllerGetAccountSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof stripeControllerGetAccountSession>>
>;

export type StripeControllerGetAccountSessionMutationError = ErrorType<unknown>;

export const useStripeControllerGetAccountSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof stripeControllerGetAccountSession>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof stripeControllerGetAccountSession>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getStripeControllerGetAccountSessionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const stripeControllerGetOnboardingLink = (
  onboardingLinkRequestDto: BodyType<OnboardingLinkRequestDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<OnboardingLinkResponseDto>(
    {
      url: `/stripe/account/onboarding-link`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: onboardingLinkRequestDto,
      signal,
    },
    options,
  );
};

export const getStripeControllerGetOnboardingLinkMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stripeControllerGetOnboardingLink>>,
    TError,
    { data: BodyType<OnboardingLinkRequestDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stripeControllerGetOnboardingLink>>,
  TError,
  { data: BodyType<OnboardingLinkRequestDto> },
  TContext
> => {
  const mutationKey = ["stripeControllerGetOnboardingLink"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stripeControllerGetOnboardingLink>>,
    { data: BodyType<OnboardingLinkRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return stripeControllerGetOnboardingLink(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StripeControllerGetOnboardingLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof stripeControllerGetOnboardingLink>>
>;
export type StripeControllerGetOnboardingLinkMutationBody =
  BodyType<OnboardingLinkRequestDto>;
export type StripeControllerGetOnboardingLinkMutationError = ErrorType<unknown>;

export const useStripeControllerGetOnboardingLink = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof stripeControllerGetOnboardingLink>>,
      TError,
      { data: BodyType<OnboardingLinkRequestDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof stripeControllerGetOnboardingLink>>,
  TError,
  { data: BodyType<OnboardingLinkRequestDto> },
  TContext
> => {
  const mutationOptions =
    getStripeControllerGetOnboardingLinkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const stripeControllerGetDashboardLink = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DashboardLinkResponseDto>(
    { url: `/stripe/account/dashboard-link`, method: "POST", signal },
    options,
  );
};

export const getStripeControllerGetDashboardLinkMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stripeControllerGetDashboardLink>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stripeControllerGetDashboardLink>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["stripeControllerGetDashboardLink"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stripeControllerGetDashboardLink>>,
    void
  > = () => {
    return stripeControllerGetDashboardLink(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StripeControllerGetDashboardLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof stripeControllerGetDashboardLink>>
>;

export type StripeControllerGetDashboardLinkMutationError = ErrorType<unknown>;

export const useStripeControllerGetDashboardLink = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof stripeControllerGetDashboardLink>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof stripeControllerGetDashboardLink>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getStripeControllerGetDashboardLinkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const stripeControllerGetCustomerPricingTableSession = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<CustomerSessionDto>(
    { url: `/stripe/customer/pricing-table`, method: "POST", signal },
    options,
  );
};

export const getStripeControllerGetCustomerPricingTableSessionMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof stripeControllerGetCustomerPricingTableSession>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof stripeControllerGetCustomerPricingTableSession>>,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["stripeControllerGetCustomerPricingTableSession"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof stripeControllerGetCustomerPricingTableSession>
      >,
      void
    > = () => {
      return stripeControllerGetCustomerPricingTableSession(requestOptions);
    };

    return { mutationFn, ...mutationOptions };
  };

export type StripeControllerGetCustomerPricingTableSessionMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof stripeControllerGetCustomerPricingTableSession>>
  >;

export type StripeControllerGetCustomerPricingTableSessionMutationError =
  ErrorType<unknown>;

export const useStripeControllerGetCustomerPricingTableSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof stripeControllerGetCustomerPricingTableSession>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof stripeControllerGetCustomerPricingTableSession>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getStripeControllerGetCustomerPricingTableSessionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const stripeControllerGetSubscriptionFromStripe = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<StripeSubscriptionDto>(
    { url: `/stripe/subscription`, method: "GET", signal },
    options,
  );
};

export const getStripeControllerGetSubscriptionFromStripeQueryKey = () => {
  return [`/stripe/subscription`] as const;
};

export const getStripeControllerGetSubscriptionFromStripeQueryOptions = <
  TData = Awaited<ReturnType<typeof stripeControllerGetSubscriptionFromStripe>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof stripeControllerGetSubscriptionFromStripe>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getStripeControllerGetSubscriptionFromStripeQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof stripeControllerGetSubscriptionFromStripe>>
  > = ({ signal }) =>
    stripeControllerGetSubscriptionFromStripe(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof stripeControllerGetSubscriptionFromStripe>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type StripeControllerGetSubscriptionFromStripeQueryResult = NonNullable<
  Awaited<ReturnType<typeof stripeControllerGetSubscriptionFromStripe>>
>;
export type StripeControllerGetSubscriptionFromStripeQueryError =
  ErrorType<unknown>;

export function useStripeControllerGetSubscriptionFromStripe<
  TData = Awaited<ReturnType<typeof stripeControllerGetSubscriptionFromStripe>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetSubscriptionFromStripe>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stripeControllerGetSubscriptionFromStripe>>,
          TError,
          Awaited<ReturnType<typeof stripeControllerGetSubscriptionFromStripe>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useStripeControllerGetSubscriptionFromStripe<
  TData = Awaited<ReturnType<typeof stripeControllerGetSubscriptionFromStripe>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetSubscriptionFromStripe>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stripeControllerGetSubscriptionFromStripe>>,
          TError,
          Awaited<ReturnType<typeof stripeControllerGetSubscriptionFromStripe>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStripeControllerGetSubscriptionFromStripe<
  TData = Awaited<ReturnType<typeof stripeControllerGetSubscriptionFromStripe>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetSubscriptionFromStripe>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useStripeControllerGetSubscriptionFromStripe<
  TData = Awaited<ReturnType<typeof stripeControllerGetSubscriptionFromStripe>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetSubscriptionFromStripe>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getStripeControllerGetSubscriptionFromStripeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const stripeControllerGetStripeAccountCapabilities = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<CapabilitiesResponseDto>(
    { url: `/stripe/capabilities`, method: "GET", signal },
    options,
  );
};

export const getStripeControllerGetStripeAccountCapabilitiesQueryKey = () => {
  return [`/stripe/capabilities`] as const;
};

export const getStripeControllerGetStripeAccountCapabilitiesQueryOptions = <
  TData = Awaited<
    ReturnType<typeof stripeControllerGetStripeAccountCapabilities>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof stripeControllerGetStripeAccountCapabilities>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getStripeControllerGetStripeAccountCapabilitiesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof stripeControllerGetStripeAccountCapabilities>>
  > = ({ signal }) =>
    stripeControllerGetStripeAccountCapabilities(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof stripeControllerGetStripeAccountCapabilities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type StripeControllerGetStripeAccountCapabilitiesQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof stripeControllerGetStripeAccountCapabilities>>
  >;
export type StripeControllerGetStripeAccountCapabilitiesQueryError =
  ErrorType<unknown>;

export function useStripeControllerGetStripeAccountCapabilities<
  TData = Awaited<
    ReturnType<typeof stripeControllerGetStripeAccountCapabilities>
  >,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof stripeControllerGetStripeAccountCapabilities>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof stripeControllerGetStripeAccountCapabilities>
          >,
          TError,
          Awaited<
            ReturnType<typeof stripeControllerGetStripeAccountCapabilities>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useStripeControllerGetStripeAccountCapabilities<
  TData = Awaited<
    ReturnType<typeof stripeControllerGetStripeAccountCapabilities>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof stripeControllerGetStripeAccountCapabilities>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof stripeControllerGetStripeAccountCapabilities>
          >,
          TError,
          Awaited<
            ReturnType<typeof stripeControllerGetStripeAccountCapabilities>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStripeControllerGetStripeAccountCapabilities<
  TData = Awaited<
    ReturnType<typeof stripeControllerGetStripeAccountCapabilities>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof stripeControllerGetStripeAccountCapabilities>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useStripeControllerGetStripeAccountCapabilities<
  TData = Awaited<
    ReturnType<typeof stripeControllerGetStripeAccountCapabilities>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof stripeControllerGetStripeAccountCapabilities>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getStripeControllerGetStripeAccountCapabilitiesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const stripeControllerGetPendingTransfersSummary = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<PendingTransfersSummaryDto>(
    { url: `/stripe/payout-account/pending-transfers`, method: "GET", signal },
    options,
  );
};

export const getStripeControllerGetPendingTransfersSummaryQueryKey = () => {
  return [`/stripe/payout-account/pending-transfers`] as const;
};

export const getStripeControllerGetPendingTransfersSummaryQueryOptions = <
  TData = Awaited<
    ReturnType<typeof stripeControllerGetPendingTransfersSummary>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof stripeControllerGetPendingTransfersSummary>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getStripeControllerGetPendingTransfersSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof stripeControllerGetPendingTransfersSummary>>
  > = ({ signal }) =>
    stripeControllerGetPendingTransfersSummary(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof stripeControllerGetPendingTransfersSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type StripeControllerGetPendingTransfersSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof stripeControllerGetPendingTransfersSummary>>
>;
export type StripeControllerGetPendingTransfersSummaryQueryError =
  ErrorType<unknown>;

export function useStripeControllerGetPendingTransfersSummary<
  TData = Awaited<
    ReturnType<typeof stripeControllerGetPendingTransfersSummary>
  >,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetPendingTransfersSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof stripeControllerGetPendingTransfersSummary>
          >,
          TError,
          Awaited<ReturnType<typeof stripeControllerGetPendingTransfersSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useStripeControllerGetPendingTransfersSummary<
  TData = Awaited<
    ReturnType<typeof stripeControllerGetPendingTransfersSummary>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetPendingTransfersSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof stripeControllerGetPendingTransfersSummary>
          >,
          TError,
          Awaited<ReturnType<typeof stripeControllerGetPendingTransfersSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStripeControllerGetPendingTransfersSummary<
  TData = Awaited<
    ReturnType<typeof stripeControllerGetPendingTransfersSummary>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetPendingTransfersSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useStripeControllerGetPendingTransfersSummary<
  TData = Awaited<
    ReturnType<typeof stripeControllerGetPendingTransfersSummary>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetPendingTransfersSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getStripeControllerGetPendingTransfersSummaryQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const stripeControllerGetNextPayout = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<NextPayoutDto>(
    { url: `/stripe/payout-account/next-payout`, method: "GET", signal },
    options,
  );
};

export const getStripeControllerGetNextPayoutQueryKey = () => {
  return [`/stripe/payout-account/next-payout`] as const;
};

export const getStripeControllerGetNextPayoutQueryOptions = <
  TData = Awaited<ReturnType<typeof stripeControllerGetNextPayout>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof stripeControllerGetNextPayout>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getStripeControllerGetNextPayoutQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof stripeControllerGetNextPayout>>
  > = ({ signal }) => stripeControllerGetNextPayout(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof stripeControllerGetNextPayout>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type StripeControllerGetNextPayoutQueryResult = NonNullable<
  Awaited<ReturnType<typeof stripeControllerGetNextPayout>>
>;
export type StripeControllerGetNextPayoutQueryError = ErrorType<unknown>;

export function useStripeControllerGetNextPayout<
  TData = Awaited<ReturnType<typeof stripeControllerGetNextPayout>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetNextPayout>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stripeControllerGetNextPayout>>,
          TError,
          Awaited<ReturnType<typeof stripeControllerGetNextPayout>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useStripeControllerGetNextPayout<
  TData = Awaited<ReturnType<typeof stripeControllerGetNextPayout>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetNextPayout>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stripeControllerGetNextPayout>>,
          TError,
          Awaited<ReturnType<typeof stripeControllerGetNextPayout>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStripeControllerGetNextPayout<
  TData = Awaited<ReturnType<typeof stripeControllerGetNextPayout>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetNextPayout>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useStripeControllerGetNextPayout<
  TData = Awaited<ReturnType<typeof stripeControllerGetNextPayout>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetNextPayout>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getStripeControllerGetNextPayoutQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const stripeControllerGetSalesHistory = (
  params?: StripeControllerGetSalesHistoryParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<SalesHistoryResponseDto>(
    { url: `/stripe/sales`, method: "GET", params, signal },
    options,
  );
};

export const getStripeControllerGetSalesHistoryQueryKey = (
  params?: StripeControllerGetSalesHistoryParams,
) => {
  return [`/stripe/sales`, ...(params ? [params] : [])] as const;
};

export const getStripeControllerGetSalesHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof stripeControllerGetSalesHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: StripeControllerGetSalesHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetSalesHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getStripeControllerGetSalesHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof stripeControllerGetSalesHistory>>
  > = ({ signal }) =>
    stripeControllerGetSalesHistory(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof stripeControllerGetSalesHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type StripeControllerGetSalesHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof stripeControllerGetSalesHistory>>
>;
export type StripeControllerGetSalesHistoryQueryError = ErrorType<unknown>;

export function useStripeControllerGetSalesHistory<
  TData = Awaited<ReturnType<typeof stripeControllerGetSalesHistory>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | StripeControllerGetSalesHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetSalesHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stripeControllerGetSalesHistory>>,
          TError,
          Awaited<ReturnType<typeof stripeControllerGetSalesHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useStripeControllerGetSalesHistory<
  TData = Awaited<ReturnType<typeof stripeControllerGetSalesHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: StripeControllerGetSalesHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetSalesHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stripeControllerGetSalesHistory>>,
          TError,
          Awaited<ReturnType<typeof stripeControllerGetSalesHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStripeControllerGetSalesHistory<
  TData = Awaited<ReturnType<typeof stripeControllerGetSalesHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: StripeControllerGetSalesHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetSalesHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useStripeControllerGetSalesHistory<
  TData = Awaited<ReturnType<typeof stripeControllerGetSalesHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: StripeControllerGetSalesHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetSalesHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getStripeControllerGetSalesHistoryQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const stripeControllerGetSalesProducts = (
  params?: StripeControllerGetSalesProductsParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<SalesProductDto[]>(
    { url: `/stripe/sales/products`, method: "GET", params, signal },
    options,
  );
};

export const getStripeControllerGetSalesProductsQueryKey = (
  params?: StripeControllerGetSalesProductsParams,
) => {
  return [`/stripe/sales/products`, ...(params ? [params] : [])] as const;
};

export const getStripeControllerGetSalesProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof stripeControllerGetSalesProducts>>,
  TError = ErrorType<unknown>,
>(
  params?: StripeControllerGetSalesProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetSalesProducts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getStripeControllerGetSalesProductsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof stripeControllerGetSalesProducts>>
  > = ({ signal }) =>
    stripeControllerGetSalesProducts(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof stripeControllerGetSalesProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type StripeControllerGetSalesProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof stripeControllerGetSalesProducts>>
>;
export type StripeControllerGetSalesProductsQueryError = ErrorType<unknown>;

export function useStripeControllerGetSalesProducts<
  TData = Awaited<ReturnType<typeof stripeControllerGetSalesProducts>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | StripeControllerGetSalesProductsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetSalesProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stripeControllerGetSalesProducts>>,
          TError,
          Awaited<ReturnType<typeof stripeControllerGetSalesProducts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useStripeControllerGetSalesProducts<
  TData = Awaited<ReturnType<typeof stripeControllerGetSalesProducts>>,
  TError = ErrorType<unknown>,
>(
  params?: StripeControllerGetSalesProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetSalesProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stripeControllerGetSalesProducts>>,
          TError,
          Awaited<ReturnType<typeof stripeControllerGetSalesProducts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStripeControllerGetSalesProducts<
  TData = Awaited<ReturnType<typeof stripeControllerGetSalesProducts>>,
  TError = ErrorType<unknown>,
>(
  params?: StripeControllerGetSalesProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetSalesProducts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useStripeControllerGetSalesProducts<
  TData = Awaited<ReturnType<typeof stripeControllerGetSalesProducts>>,
  TError = ErrorType<unknown>,
>(
  params?: StripeControllerGetSalesProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerGetSalesProducts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getStripeControllerGetSalesProductsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const stripeControllerExportSalesCsv = (
  params?: StripeControllerExportSalesCsvParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<string>(
    { url: `/stripe/sales/export`, method: "GET", params, signal },
    options,
  );
};

export const getStripeControllerExportSalesCsvQueryKey = (
  params?: StripeControllerExportSalesCsvParams,
) => {
  return [`/stripe/sales/export`, ...(params ? [params] : [])] as const;
};

export const getStripeControllerExportSalesCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof stripeControllerExportSalesCsv>>,
  TError = ErrorType<unknown>,
>(
  params?: StripeControllerExportSalesCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerExportSalesCsv>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getStripeControllerExportSalesCsvQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof stripeControllerExportSalesCsv>>
  > = ({ signal }) =>
    stripeControllerExportSalesCsv(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof stripeControllerExportSalesCsv>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type StripeControllerExportSalesCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof stripeControllerExportSalesCsv>>
>;
export type StripeControllerExportSalesCsvQueryError = ErrorType<unknown>;

export function useStripeControllerExportSalesCsv<
  TData = Awaited<ReturnType<typeof stripeControllerExportSalesCsv>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | StripeControllerExportSalesCsvParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerExportSalesCsv>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stripeControllerExportSalesCsv>>,
          TError,
          Awaited<ReturnType<typeof stripeControllerExportSalesCsv>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useStripeControllerExportSalesCsv<
  TData = Awaited<ReturnType<typeof stripeControllerExportSalesCsv>>,
  TError = ErrorType<unknown>,
>(
  params?: StripeControllerExportSalesCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerExportSalesCsv>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stripeControllerExportSalesCsv>>,
          TError,
          Awaited<ReturnType<typeof stripeControllerExportSalesCsv>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStripeControllerExportSalesCsv<
  TData = Awaited<ReturnType<typeof stripeControllerExportSalesCsv>>,
  TError = ErrorType<unknown>,
>(
  params?: StripeControllerExportSalesCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerExportSalesCsv>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useStripeControllerExportSalesCsv<
  TData = Awaited<ReturnType<typeof stripeControllerExportSalesCsv>>,
  TError = ErrorType<unknown>,
>(
  params?: StripeControllerExportSalesCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof stripeControllerExportSalesCsv>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getStripeControllerExportSalesCsvQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
